import Invoice from '../../src/legacy/Invoice';
export default Invoice;
